<div class="container-fluid float-end pt-lg-4 pb-lg-5">
  <div class="container-lg">
    <div class="row text-center">
      <div class="mt-5 mt-sm-5 my-lg-2 mt-lg-3 text-lg-start">
        <img src="/assets/images/WeShape-logo.png" alt="WeShape Logo" id="logo">
      </div>
      <div class="col-lg-2 links order-lg-2 my-4 my-sm-3 my-lg-0">
        <div class="mb-2"><a [href]="getWWWUrl('')">Home</a></div>
        <div class="mb-2"><a [href]="getWWWUrl('how-it-works')">How It Works</a></div>
        <div class="mb-2"><a href="https://support.weshape.com" target="_blank">FAQ</a></div>
        <div class="mb-2"><a href="https://my.weshape.com/login" target="_blank">Sign In</a></div>
      </div>
      <div class="col-lg-3 social mb-5 order-lg-3">
        <div class="mb-2 make-sure">Make Sure to Follow Us On</div>
        <div class="justify-content-center">
          <div class="d-flex justify-content-center">
            <a href="https://www.facebook.com/WeShape/" target="_blank">
              <img src="/assets/images/facebook-icon.png" alt="Facebook Icon">
            </a>
            <div class="pe-1 ps-2">
              <a href="https://www.youtube.com/channel/UCZjFDJI4B4l16uujibduMFA/" target="_blank">
                <img src="/assets/images/youtube-icon.png" alt="Youtube Icon">
              </a>
            </div>
            <div class="pe-2 ps-1">
              <a href="https://www.instagram.com/weshape.wellness/" target="_blank">
                <img src="/assets/images/instagram-icon.png" alt="Instagram Icon">
              </a>
            </div>
            <a href="https://www.tiktok.com/@weshape" target="_blank">
              <img src="/assets/images/tiktok-icon.png" alt="TikTok Icon">
            </a>
          </div>
        </div>
      </div>
      <div class="container disclaimer order-lg-1 col-lg-7 mb-5 mb-sm-5 mb-lg-3 text-lg-start">
        <b>DISCLAIMER</b>: This site provides general information for you to discuss with your physician. This site does
        not provide any professional advice or services. The ideas, procedures, and suggestions contained here are not a
        substitute for consulting with your physician, and should only be used as part of planning your development of
        an
        overall health and fitness plan with your physician. All matters regarding your health require medical
        supervision. Our <a [href]="getWWWUrl('terms-and-conditions')">TERMS OF SERVICE</a> limit our liability to you, and you are required to read
        and agree to them before using our site.
        <p class="weshape mt-3">&copy; WeShape 2026</p>
        <div class="d-flex justify-content-center justify-content-sm-center justify-content-lg-start resourses">
          <div class="d-flex justify-content-center">
            <a [href]="getWWWUrl('terms-and-conditions')" target="_blank">
              Terms
            </a>
          </div>
          <div class="pp-container px-1 mx-1 d-flex justify-content-center">
            <a [href]="getWWWUrl('privacy-policy')" target="_blank">
              Privacy Policy
            </a>
          </div>
          <div class="d-flex justify-content-center">
            <a [href]="getWWWUrl('do-not-sell')" target="_blank">
              Do Not Sell
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>